<div class="modal-header pt-4 px-4">
    <h4 class="modal-title primary-textcolor" *ngIf="title">{{ title }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()" *ngIf="cancel">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body px-4" *ngIf="message">
    {{ message }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onModalHidden()">{{ confirm }}</button>
    <button type="button" class="btn btn-primary" *ngIf="cancel" (click)="bsModalRef.hide()">Cancel</button>
</div>
